import { proceedToCheckout, setCartRemainingInventory, triggerAlert, mailSignup, getEmail,postData, getPoints } from "./network.js?1791546422";
import State from "./state.js?7432987235";
let state = new State();


(async ()=>{
  window.roucha_state = state;
  window.roucha_state.init();
  await window.roucha_state.ready
  // if(roucha_state.get("savedSize"))
    // $(".login-toggle").text(`ACCOUNT (${roucha_state.get("savedSize")})`);
//   if(roucha_state.get("wishlist").length){
//     $("#empty-with-wishlist").addClass("active");
//   }
  setCartRemainingInventory();
})()



//----------------------------------------------
// Nav toggling logic
//----------------------------------------------

document.addEventListener("scroll", function(e) {
    if(window.scrollY>43){
      $("body").addClass("promo-gone")
    }
    if(window.scrollY>0 && !$("body").hasClass("scrolled")){
      $("body").addClass("scrolled")
    } else if (window.scrollY === 0 && $("body").hasClass("scrolled")) {
      $("body").removeClass("scrolled promo-gone")
    }
},  {passive: true});

let closeCartTimeout;
let navColors = $("header").attr("nav-colors").split(",");


$(document).on("click",".cart-link.hovered",(e)=>{
  $(".cart-link").removeClass("hovered");
  $("#mini-cart, header").removeClass("toggled");
});

$(document).on("mouseleave","#mini-cart",(e)=>{
    $(".cart-link").removeClass("hovered");
    $("#mini-cart,header").removeClass("toggled");
    $("header").addClass("gradient");
}).on("mouseenter","#mini-cart",(e)=>{
  $(".cart-link").addClass("hovered");
$("#mini-cart,header").addClass("toggled");
    clearTimeout(closeCartTimeout);
});

const initMobile = () => {
    $("#checkout").removeClass("loading");
    $(document).on("touchstart click",".menu-toggle.mobile-nav",(e)=>{
        e.preventDefault();
        e.stopPropagation()
        $("#menu-container").addClass("active");
        $("#menu-container").addClass("opening");
        setTimeout(() => {
            $("#menu-container").removeClass("opening");
        },250)
    })
    $(document).on("click","#menu-items-mobile .subnav-title",(e)=>{
        console.log(" new mobile nav handler")
        e.preventDefault();
        e.stopPropagation();
        $(e.target).closest(".menu-item").toggleClass("closed");
    });

    $(document).on("touchend",".menu-toggle.mobile-nav, #menu-container.opening",(e)=>{
        e.preventDefault();
    });
    //on click mobile-search-link, toggle the search modal class active
    $(document).on("click",".mobile-search-toggle",(e)=>{
        e.preventDefault();
        e.stopPropagation();
        $("#search-modal").toggleClass("active");
        $("#search-modal input").focus();
    });
}

$(document).ready(function(){
  if(window.innerWidth<1100){
    initMobile();
  }



  
  $("#mobile-heart-link").click((e)=>{
    //if user not logged in, toggle the login modal
    if(!roucha_state.get("id").length){
      e.preventDefault();
      e.stopPropagation();
      $("#customer-login").toggleClass("active")
    }
    });

    const leftPositionMenus = () => {
        $("#left-nav .desktop-nav.nav-item").each((i,el)=>{
            let offset = $(el).offset().left-24;
            $(`.menu.desktop-nav.menu-${$(el).attr("nav-link")} .menu-items`).css("translate",`${offset}px 0`);
        });
        
    }
        
    leftPositionMenus();
    window.addEventListener('resize', leftPositionMenus, { passive: true });
    // window.addEventListener('resize', initMobile, { passive: true });
});
//END DOCUMENT READY
let totalDropdownMenus = $("#menu-container .menu.desktop-nav").length;
//calculate offset of nav-items and set corresponding .menus to have the same offset

let menuTimeout;

$(".nav-item.menu-toggle").mouseenter((e)=>{
    clearTimeout(menuTimeout);
    let index = $(e.target).attr("nav-link");
    let activeMenu = $(`.menu.desktop-nav.menu-${index}`);
    if(!!!index || !activeMenu.length){
        console.log(index,navColors)
        closeMenu(navColors[index-1]);
        $("#shopify-section-header").css("background",navColors[index-1]);
        return;
    };
    console.log("entering nav item",index)
    $("#menu-container").addClass("active").attr("active-menu",$(e.target).attr("nav-link"));
    $("#shopify-section-header").css("background",navColors[index-1]);
    $("header").addClass("menu-open");

    //set menu container to height of active menu
    let height = activeMenu.height();
    $("#menu-container").css("height",height+50+"px");
})

const closeMenu = (color) => {
    console.log("closing menu")
    $("#menu-container").removeClass("active");
    menuTimeout = setTimeout(() => {
        $("header").removeClass("menu-open");
        $("#shopify-section-header").css("background","white");
        if(color){
            $("#shopify-section-header").css("background",color);
        }
    },250);
}

if(window.innerWidth>1100){
    $("#menu-container").mouseleave(closeMenu);
    $(window).scroll(() => {if(window.innerWidth>1100){closeMenu()}});
}

$("#menu-x, .ss__autocomplete__input--mobile").click(closeMenu);

$(".ss__autocomplete__input--mobile").click(()=>{
    $("#search-modal").toggleClass("active");
    //focus on the search input
    $("#search-modal input").focus();
});

  $(document).on("mouseleave", "header:not(.active),.no-submenu .nav-item",function(e){
    $("header").removeClass("no-submenu active").addClass("gradient");
    $(e.target).removeClass("active");
  })

//----------------------------------------------
// End Nav toggling logic
//----------------------------------------------


//----------------------------------------------
// Misc click events - color picker, modal, sign in button, mailing list
//----------------------------------------------
$(".color-picker").mouseenter((e)=>{
  $(e.target).closest(".color-picker").addClass("hovering")
}).mouseleave((e)=>{
  $(e.target).closest(".color-picker").removeClass("hovering")
})

$(".modal").click(e => {
    console.log("please close",$(e.target))
  if($(e.target).hasClass("modal","x")|| $(e.target).hasClass("x") || $(e.target).parent().hasClass("x")){

    if($(e.target).hasClass("no-close")){
      window.location = "/"
    } else {
      $(e.target).closest(".modal").toggleClass("active")
    }
  }
  if($(".modal.active").length){
    $("body").addClass("noscroll")
  } else {
    $("body").removeClass("noscroll")
  }
})

//delegated: cart line items (and their data-modal-toggle="login" Save For Later
//buttons) get replaced when #cart-items re-renders, and a direct binding was
//lost with the old elements, so the second click did nothing
$(document).on("click","[data-modal-toggle]",(e)=> {
  e.preventDefault();
  if(!$(e.target).closest(".save-for-later"))
  e.stopPropagation();
  $(`.modal.active`).removeClass("active");
  let modal = $(e.target).closest("[data-modal-toggle]").attr("data-modal-toggle");
  console.log("clicked modal....",modal,e)
  $("#mini-cart.toggled, header.toggled").toggleClass("toggled");
  //addClass, not toggle: this link always opens, whatever state it was left in
  $(`[data-modal-name='${modal}']`).addClass("active");
  if($(".modal.active").length){
    $("body").addClass("noscroll")
  } else {
    $("body").removeClass("noscroll")
  }
})

$("#check-email").click(async(e)=>{
  e.preventDefault();
  e.stopPropagation();
  let value = $("#login-form input#email-input").val()
  let result = await getEmail(value)
  if(result.id){
    $("#customer-login").toggleClass("active")
    $("#customer-return").toggleClass("active")
    $("#CustomerEmail").attr("value",value);
  } else {
    $("#customer-login").toggleClass("active")
    $("#customer-register").toggleClass("active")
    $("#RegisterForm-email").attr("value",value);
  }
})

$(".wrong-place").click((e)=>{
  $("#customer-login").toggleClass("active")
  $("#customer-register").toggleClass("active")
});

$("#the-mailing-form, #footer-the-mailing-form").submit(async (e)=>{
  e.preventDefault();
  e.stopPropagation();
  await mailSignup($(".mailing-section-form").val());
  e.target.reset();
})

//----------------------------------------------
// End misc click events
//----------------------------------------------

//----------------------------------------------
// Keyboard arrow scrolling logic
//----------------------------------------------
document.addEventListener('keydown', function(e){
  if(e.which !== 38 && e.which !== 40){
    return;
  }
  let positions = []
  let mainDivs = $("#main > *").toArray().filter(el => $(el).height()>0);
  mainDivs.forEach((el)=> positions.push(getCoords(el)))
  console.log(positions)
  let scroll = window.scrollY;
  let ht = window.innerHeight;
  let prevIndex = positions.findIndex(p => p < scroll && p+window.innerHeight > scroll);
  let nextIndex = scroll === 0 ? 1 : positions.findIndex(p => p > scroll);
  console.log({scroll,positions,prevIndex,nextIndex})
  if(nextIndex > positions.length || nextIndex === 0){
    console.log("aborting scroll")
    return;
  }
  // el.scrollIntoView({behavior:"smooth"});
  switch (e.which) {
    case 38:
      console.log("scrolling bwd")
      if(mainDivs[prevIndex]){
        mainDivs[prevIndex].scrollIntoView({behavior:"smooth"});
        e.preventDefault();
      }
    break;
    case 40:
      console.log("scrolling fwd")
      if(mainDivs[nextIndex]){
        mainDivs[nextIndex].scrollIntoView({behavior:"smooth"});
        e.preventDefault();
      }
    break;
    default:

  }
});

function getCoords(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();
    var body = document.body;
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var top  = box.top +  scrollTop - clientTop;
    return Math.round(top);
}
//----------------------------------------------
//End Keyboard arrow scrolling logic
//----------------------------------------------
$("#create-account, .customer-nav-item:last-child").click(function(e){
  if(localStorage && localStorage.roucha_state){
    delete localStorage.roucha_state;
  }
})
//----------------------------------------------
// Checkout buttons
//----------------------------------------------
$("#checkout, #mini-cart-checkout").click(function(e){
  e.preventDefault();
  e.stopPropagation();
  $(e.target).closest(".action-button").addClass("loading");
  // proceedToCheckout();
  window.location = "/cart"
})
//----------------------------------------------
// End Checkout Buttons
//----------------------------------------------


//----------------------------------------------
// Force cart updates
//----------------------------------------------
if(!localStorage.getItem("cartUpdated")){
    localStorage.setItem("cartUpdated",new Date().getTime());
    forceCartUpdate();
  } else {
      let cartUpdated = localStorage.getItem("cartUpdated");
      let now = new Date().getTime();
      let timeSince = now - cartUpdated;
      let hoursSince = timeSince / 1000 / 60 / 60;
      console.log("hours since",hoursSince)
      if(hoursSince > 1){
          forceCartUpdate();
          localStorage.setItem("cartUpdated",now);
      }
  }
  //save a date in localStorage called cartUpdated. every time a user gets to this page, update the value. If the current value is more than 24 hours old, run the forceCartUpdate function
    async function forceCartUpdate(){
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: {},
            }),
        }).catch(function(error) {
        console.error('Error:', error);
        }).then(d => d.json()).then(console.log);
    }
//----------------------------------------------
// End Force cart updates
//----------------------------------------------



  //on document loaded, loop through every .special-collection-block
//find the text value of its contained .selected .color-label, and append that value to .product-grid-item-title
//add an attr to show you did it so you don't do it again

$(document).ready(function(){
    $(".special-collection-block .product-grid-item").each((i,el)=>{
        if($(el).attr("data-color-added")) return;
        let color = $(el).find(".selected > .color-label").text();
        console.log({color:$(el).find(".selected > .color-label")})
        $(el).find(".product-grid-item-title").append(`<div class="color-label"> ${color}</div>`)
        $(el).attr("data-color-added",true);
    })
});


// ['resize', 'scroll', 'touchmove', 'gesturechange'].forEach(evt => {
//   window.addEventListener(evt, () => {
//     console.log(evt, performance.now());
//   }, { passive: true });
// });

window.addEventListener('gesturechange', e => {
  e.preventDefault();
}, { passive: false });

// window.addEventListener('touchmove', e => {
//   if (e.scale !== undefined) e.preventDefault();
// }, { passive: false });